import { LegalLayout } from "../components/LegalLayout";
import { TERMS_PAGE } from "../data/legalPages";

export default function Terms() {
  return <LegalLayout page={TERMS_PAGE} testId="terms-page" />;
}
